    <template>
      <div class="wingo-game">

        <!-- ANA ALAN (Header + History + Orta + Sağ panel) -->
        <div class="main-layout">

          <!-- SOL ALAN -->
          <div class="center-content">

            <!-- MOBİL İÇİN (En Üstte) -->
    <div class="mobile-only">
      <HistoryBar :history="roundHistory" :socket="socket" />
    </div>
            <!-- ÜST -->
            <GameHeader
  :session-id="sessionId"
  :deadline="deadline"
  :online-players="onlinePlayers"
/>


            <!-- RENK & SAYI -->
          <ColorBets
      :selected="selectedColor"
      :bets="colorBets"
      :socket="socket"
      :roundId="sessionId"
      :user="authUser"
      @select="selectColor"
    />
            <NumberBets
      :selected="selectedNumber"
      :bets="numberBets"
      :socket="socket"
      :roundId="sessionId"
      :user="authUser"
      @select="selectNumber"
    />

            

        <CountdownBar
  :deadline="deadline"
  :max-time="roundDuration"
  :server-offset="serverOffset"
/>


            <!-- PC'de burada HistoryBar göster -->
          <div class="desktop-only">
            <HistoryBar :history="roundHistory" />
          </div>

            <BetAmount v-model="betAmount" />
          </div>

          <!-- SAĞ PANEL (PC) -->
          <div class="bets-panel desktop-only">
            <PlayerBets :bets="playerBets" :authUser="authUser" :myBets="myBets" />


          </div>

        </div>

        <!-- ALTTA (Mobil) -->
        <div class="mobile-only" style="margin-top: 15px;">
          <PlayerBets :bets="playerBets" :authUser="authUser" :myBets="myBets" />


        </div>
<ModalWingoResult
  :visible="modalResultVisible"
  :result="modalResultData"
  @close="modalResultVisible = false"
/>
      </div>
    </template>

    <script setup>
    import { ref, computed, onMounted } from 'vue'
    import { useStore } from 'vuex'
    import { io } from 'socket.io-client'
    import axios from 'axios'
    import moment from 'moment'
    import ModalWingoResult from '@/components/wingo/ModalWingoResult.vue'

    import GameHeader from '@/components/wingo/GameHeader.vue'
    import ColorBets from '@/components/wingo/ColorBets.vue'
    import NumberBets from '@/components/wingo/NumberBets.vue'
    import CountdownBar from '@/components/wingo/CountdownBar.vue'
    import HistoryBar from '@/components/wingo/HistoryBar.vue'
    import BetAmount from '@/components/wingo/BetAmount.vue'
    import PlayerBets from '@/components/wingo/PlayerBets.vue'

    const modalResultData = ref(null)
const modalResultVisible = ref(false)
const serverOffset = ref(0)
const roundDuration = ref(30)
    const store = useStore()
    const authUser = computed(() => store.getters.authUser.user)
    const socket = io('https://play.rivobit.com', {
      transports: ['websocket'],
      withCredentials: true
    })

    const sessionId = ref(null)
    const onlinePlayers = ref(0)
    const betAmount = ref(10)
const deadline = ref(
  moment().add(30, 'seconds').format('YYYY-MM-DD HH:mm:ss')
)
    const selectedColor = ref(null)
    const selectedNumber = ref(null)

    const roundHistory = ref([])
    const rawBets = ref([])
    const myBets = ref([])

    const colorBets = ref({})
    const numberBets = ref({})

    const playerBets = computed(() => {
      const merged = {}

      for (let i = rawBets.value.length - 1; i >= 0; i--) {
        const bet = rawBets.value[i]
        const key = `${bet.username}-${bet.selection}`

        if (!merged[key]) {
          merged[key] = {
            username: bet.username,
            selection: bet.selection,
            amount: 0,
            avatar: bet.avatar,
            fiatCurrency: bet.fiatCurrency,
            wallet: bet.wallet
          }
        }

        merged[key].amount += bet.amount
      }

      return Object.values(merged).slice(0, 10)
    })

    const selectColor = (colorKey) => {
      selectedColor.value = colorKey
      selectedNumber.value = null
    }

    const selectNumber = (num) => {
      selectedNumber.value = num
      selectedColor.value = null
    }

    const resetBets = () => {
      rawBets.value = []
      colorBets.value = {}
      numberBets.value = {}
    }

    const updateMyBalance = async () => {
      try {
        const res = await fetch(`https://play.rivobit.com/auth/me`, {
          headers: {
            'x-auth-token': localStorage.getItem('token')
          }
        })

        if (res.ok) {
          const data = await res.json()
          store.commit('auth_set_user', data.user)
        }
      } catch (e) {
        console.error('[BALANCE] Güncellenemedi:', e)
      }
    }

    onMounted(async () => {

      socket.on('server:time', ({ now }) => {
  serverOffset.value = now - Date.now()
  console.log('[SERVER OFFSET]', serverOffset.value, 'ms')
})

      const token = localStorage.getItem('token')
      const userId = authUser.value?._id

      if (token) {
        socket.emit('authenticate', { token })
      }

      // ✅ Kullanıcının bahis geçmişini doğrudan API'den çek
      if (userId) {
        try {
          const res = await axios.get(`https://play.rivobit.com/wingo/bets`, {
            params: { userId, limit: 50 }
          })

          if (res.data.success) {
          
          myBets.value = res.data.bets.map(bet => ({
      roundId: bet.roundId,
      selection: bet.selection ?? bet.choice, // Eski API desteği için
      amount: bet.amount,
      profit: bet.payout != null ? bet.payout - bet.amount : null,
      wallet: bet.wallet
    }))
          
          }
        } catch (err) {
          console.warn('[MY BETS API ERROR]', err.message)
        }
      }

   socket.on('wingo:round:start', ({ roundId, endsAt }) => {
  sessionId.value = roundId
  deadline.value = moment(endsAt).format('YYYY-MM-DD HH:mm:ss')

  // backend 30sn ise burada da 30 olur (ms → sn)
  roundDuration.value = 30

  resetBets()
})



      socket.on('wingo:round:result', ({ result }) => {
  roundHistory.value.unshift(result.number)
  if (roundHistory.value.length > 20) roundHistory.value.pop()

 
})

socket.on('wingo:round:complete', async (payload) => {
  if (!payload || !payload.roundId) {
    console.warn('[WINGO] wingo:round:complete payload geçersiz:', payload)
    return
  }

  const { roundId } = payload

  resetBets()

  try {
    const { data } = await axios.get(`https://play.rivobit.com/wingo/result/${roundId}`)

    if (data.success) {
      const result = data.result
      const myId = authUser.value?._id
    const myBets = result.bets.filter(b => b.userId === myId)

const totalBet = myBets.reduce((acc, bet) => acc + bet.amount, 0)
const totalWin = myBets.reduce((acc, bet) => acc + bet.payout, 0)
const totalProfit = totalWin - totalBet
const userBet = myBets.length > 0

modalResultData.value = {
  color: result.color,
  number: result.number,
  roundId: result.roundId,
  profit: totalProfit,
  totalBet,
  totalWin,
  userBet,
  currency: myBets[0]?.wallet?.currency || '',
  coinIcon: myBets[0]?.wallet?.coinType
    ? `/img/coins/${myBets[0].wallet.coinType}.svg`
    : ''
}

     if (userBet) {
  modalResultVisible.value = true   // Modal açılır
  store.dispatch('authGetUser')     // ✅ Kullanıcı verisi güncellenir
}

      
    }
  } catch (err) {
    console.error('Round sonucu alınamadı:', err)
  }
})


      socket.on('wingo:players:online', (count) => {
        onlinePlayers.value = count
      })

      socket.on('wingo:bet:result', ({ bets }) => {
    myBets.value = bets.map(bet => ({
      roundId: bet.roundId,
      selection: bet.selection,
      amount: bet.amount,
      profit: bet.profit,
      wallet: bet.wallet // ✅ burada wallet bilgisini de al
    }))
  })

      socket.on('wingo:bet:sync', ({ bets }) => {
        for (const bet of bets) {
          rawBets.value.push({
            username: '...',
            selection: bet.choice,
            amount: bet.amount,
            wallet: bet.wallet
          })
        }
      })

      socket.on('wingo:bet:new', ({ userId, username, avatar, bets }) => {
        const me = authUser.value
        for (const bet of bets) {
          rawBets.value.push({
            username: userId === me?._id ? 'Sen' : username,
            avatar: userId === me?._id ? me.avatar : avatar,
            selection: bet.choice,
            amount: bet.amount,
            wallet: bet.wallet
          })
        }
      })

      socket.on('wingo:balance:update', ({ wallets }) => {
        store.commit('auth_update_user', { wallets })
      })

      socket.on('wingo:bet:success', () => {
        updateMyBalance()
      })

   

      // İlk geçmiş verisi
      socket.emit('wingo:history:request')
      socket.on('wingo:history:response', (history) => {
        roundHistory.value = history
      })
    })
    </script>



  <style scoped>
  .wingo-game {
    padding: 1rem;
    max-width: 1280px;
    margin: auto;
    color: white;
  }

  .main-layout {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: stretch;
  }

  .center-content {
    flex: 3;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .bets-panel {
    flex: 1;
    min-width: 220px;
  }

  .place-button-wrapper {
    display: flex;
    justify-content: center;
  }

  .place-bet-button {
    padding: 0.6rem 2rem;
    background-color: #00ff94;
    color: black;
    border: none;
    border-radius: 8px;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
    transition: 0.2s ease;
  }
  .place-bet-button:disabled {
    background-color: #555;
    color: #aaa;
    cursor: not-allowed;
  }

  /* Mobil Uyum */
  @media (max-width: 768px) {
    .main-layout {
      flex-direction: column;
    }

    .desktop-only {
      display: none !important;
    }

    .mobile-only {
      display: block !important;
       
      
    }
  }

  @media (min-width: 769px) {
    .mobile-only {
      display: none !important;
    }

    .desktop-only {
      display: block !important;
    }
  }
  </style>
